<template>
  <div class="mb-5">
    <template v-if="$helper.currencyOptions.length > 1">
      <div class="bg-white d-flex align-center justify-space-between">
        <v-tabs
          v-model="tab"
          color="primary"
          slider-color="primary"
          background-color="white">
          <template v-if="$helper.currencyOptions.length > 1">
            <template v-for="currency in $helper.currencyOptions">
              <v-tab :value="currency.value" :href="`#${currency.value}`" @click="onSelectTab(currency.value)" :key="`tab-accountingproduct-${currency.value}`">
                <img :src="`/images/currency/${currency.value}.svg`" :alt="currency.value" class="mr-2 tab-icon-flag">
                {{ currency.tabName }}
              </v-tab>
            </template>
          </template>
        </v-tabs>
        <v-btn style="float:right;" class="blue white--text mx-1" link to="settingtask-areaacc"
          active-class="white--text primary" outlined elevation="0">
          {{ $t('task.send_bill_to_approve')}}
          <v-chip v-if="countSettingTasks" color="error" style="height: 24px;padding:0 8px;margin-left:5px;">{{
            countSettingTasks }}</v-chip>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="currency in $helper.currencyOptions" :key="currency.value" :value="`${currency.value}`">
          <MarketSettingAccountingproduct 
          :isMainLoading="isMainLoading" 
          @onInitAreaaccountingproduct="initData" 
          @onExportAreaAccounting="exportAreaAccounting" 
          :tabType="currency.value" 
          :projectId="projectId" 
          :marketId="marketId"    
          :areasAccountingItems="areasAccountingItems"/>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else>
      <div>
        <v-btn style="float:right;margin-top: 12px;" class="blue white--text ms-2" link to="settingtask-areaacc"
          active-class="white--text primary" outlined elevation="0">
          {{ $t('task.send_bill_to_approve')}}
          <v-chip v-if="countSettingTasks" color="error" style="height: 24px;padding:0 8px;margin-left:5px;">{{
            countSettingTasks }}</v-chip>
        </v-btn>
      </div>
      <MarketSettingAccountingproduct 
        :isMainLoading="isMainLoading" 
        @onInitAreaaccountingproduct="initData" 
        @onExportAreaAccounting="exportAreaAccounting" 
        :tabType="tab" 
        :projectId="projectId" 
        :marketId="marketId" 
        :areasAccountingItems="areasAccountingItems"/>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MarketSettingAccountingproduct from "@/components/MarketSettingAccountingproduct.component.vue";
export default {
  components: {
    MarketSettingAccountingproduct
  },
  props: {
    isMainLoading: Boolean,
    marketId: String,
    projectId: String,
    areasAccountingItems: Object
  },
  computed: {
    ...mapGetters({
      countSettingTasks: "settingTask/countSettingTasks",
    }),
  },
  data() {
    return {
      tab: this.$globalCurrencyCode,
    };
  },
  watch: {},
  mounted() {
  },
  methods: {
    initData() {
      this.$emit("onInitAreaaccountingproduct");
    },
    exportAreaAccounting() {
      this.$emit("onExportAreaAccounting");
    },
    onSelectTab(tab) {
      this.$emit("onInitAreaaccountingproduct",{tab:this.tab});
      this.$emit("onSelectTab", tab);
    }
  }
};
</script>
